namespace Serenity {

    @Serenity.Decorators.element('<div/>')
    @Serenity.Decorators.registerEditor('Serenity.YesNoCheckEditor', [ISetEditValue, IGetEditValue, IReadOnly])
    export class YesNoCheckEditor extends Widget<any> implements IGetEditValue, ISetEditValue, IReadOnly {

        constructor(div: JQuery) {
            super(div);

            this.addCheck('1', Q.text('Dialogs.YesButton'));
            this.addCheck('0', Q.text('Dialogs.NoButton'));
        }

        get_readOnly(): boolean {
            return this.element.find('input[type=checkbox').first().is(':disabled');
        }

        set_readOnly(value: boolean): void {
            Serenity.EditorUtils.setReadonly(this.element.find('input[type=checkbox'), !!value);
        }

        protected addCheck(value: string, text: string) {
            var label = $('<label/>').text(text);
            $('<input type="checkbox"/>').attr('name', this.uniqueName)
                .attr('id', this.uniqueName + '_' + value)
                .attr('value', value).prependTo(label)
                .click(e => this.element.find('input:checked').not(e.target)
                    .each((i, e) => (e as HTMLInputElement).checked = false));
            label.appendTo(this.element);
        }

        get_value(): boolean {
            var val = this.element.find('input:checked').first().val();
            if (val == null)
                return null;
            if (val.toString() === "1")
                return true;

            return false;
        }

        get value(): boolean {
            return this.get_value();
        }

        set_value(value: boolean): void {
            if (value !== this.get_value()) {
                var inputs = this.element.find('input');
                var checks = inputs.filter(':checked').each((i, e) => (e as HTMLInputElement).checked = false);
                if (value != null) {
                    checks = inputs.filter('[value=' + (value ? "1" : "0") + ']');
                    if (checks.length > 0) {
                        (checks[0] as HTMLInputElement).checked = true;
                    }
                }
            }
        }

        set value(v: boolean) {
            this.set_value(v);
        }

        setEditValue(source: any, property: PropertyItem): void {
            var value = source[property.name];
            if (value == null || value === "")
                this.value = null;
            else 
                this.value = !!value;
        }

        getEditValue(property: PropertyItem, target: any): void {
            target[property.name] = this.value;
        }
    }
}